export const buttonFocusRingClasses =
  'outline-none focus-visible:border-ring focus-visible:ring-border-light focus-visible:ring-2';
